const ROUTE = {
    LANDING : '/',
    HOME : '/home',
    DETAIL : '/detail',
    CREATE: '/create',
    ERROR: '/404',
    NOT_FOUND: '/404'
}

export default ROUTE